<app-container [error]="'SER_ERR_500'" [loading]="false">
  <app-second-btn [text]="'Back'" (click)="back()"></app-second-btn>
</app-container>
